import { useSyncExternalStore } from "react";

const LANDED_MS = 4000;

let landed: ReadonlySet<string> = new Set();
const timers = new Map<string, ReturnType<typeof setTimeout>>();
const listeners = new Set<() => void>();

const emit = (next: ReadonlySet<string>) => {
  landed = next;
  for (const listener of listeners) listener();
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const versionKey = (nodeId: string, version: number) => `${nodeId}#${version}`;

/** Marks rows that just arrived from an upload so the list can greet them once. */
export const markLanded = (...keys: string[]) => {
  emit(new Set([...landed, ...keys]));
  for (const key of keys) {
    const previous = timers.get(key);
    if (previous !== undefined) clearTimeout(previous);
    timers.set(
      key,
      setTimeout(() => {
        timers.delete(key);
        const next = new Set(landed);
        next.delete(key);
        emit(next);
      }, LANDED_MS),
    );
  }
};

export const useLanded = () => useSyncExternalStore(subscribe, () => landed);
